import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import RequireAuth from "@/components/RequireAuth";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Strategies from "@/pages/Strategies";
import OptionChain from "@/pages/OptionChain";
import Positions from "@/pages/Positions";
import MtmChart from "@/pages/MtmChart";
import BrokerSettings from "@/pages/BrokerSettings";
import OAuthCallback from "@/pages/OAuthCallback";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login mode="login" />} />
          <Route path="/register" element={<Login mode="register" />} />

          {/*
            OAuth callback — rendered outside RequireAuth and Layout because:
            - It lives in a popup window (no nav needed)
            - Auth is handled via the `state` JWT param, not localStorage
          */}
          <Route path="/broker-callback/:broker" element={<OAuthCallback />} />
          <Route path="/mtm-chart" element={<RequireAuth><MtmChart /></RequireAuth>} />

          <Route element={<RequireAuth><Layout /></RequireAuth>}>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/strategies" element={<Strategies />} />
            <Route path="/option-chain" element={<OptionChain />} />
            <Route path="/positions" element={<Positions />} />
            <Route path="/settings" element={<BrokerSettings />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}